<template>
    <page :showDashboardButton="true">
        <!-- <template v-slot:header>
      <ion-title>Verträge</ion-title>
    </template> -->
        <h1 class="u-m-bottom-large">Produkte</h1>
        <ion-grid>
            <ion-row>
                <template v-if="typeof $store.state.checklists === 'object'">
                    <ion-col
                        size-md="6"
                        size="12"
                        style="padding-bottom: 0; padding-top: 0;"
                        v-for="(checklist, key) in $store.state.checklists"
                        :key="key"
                    >
                        <contract-icon-card
                            :isKreditcheckliste="true"
                            :date="checklist.date"
                            :description="checklist.description"
                            :checklistKey="key"
                        ></contract-icon-card>
                    </ion-col>
                </template>

                <template
                    v-for="(contract, contractKey) in $store.state.contracts"
                >
                    <ion-col
                        size-md="6"
                        size="12"
                        :key="contractKey"
                        style="padding-bottom: 0; padding-top: 0;"
                    >
                        <contract-icon-card
                            :contractId="contract.ContractId"
                        ></contract-icon-card>
                    </ion-col>
                </template>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import ContractIconCard from "@/components/ContractIconCard";
import Page from "@/components/Page";

export default {
    components: { ContractIconCard, Page },
    data() {
        return {};
    },
    // mounted() {
    //   this.$store.dispatch(
    //     "contractsDetails/getContractDetails",
    //     this.contractId
    //   );
    // },
    methods: {}
};
</script>

<style lang="scss" scoped></style>
